var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.postMsgs && _vm.postMsgs.length > 0
  var g1 = _vm.windowSpuList && _vm.windowSpuList.length > 0
  var g2 = _vm.windowSpuList && _vm.windowSpuList.length > 0
  var l0 = g2
    ? _vm.__map(_vm.windowSpuList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var m0 = _vm.style(400)
        var g3 = _vm.windowSpuList.length
        var g4 = _vm.windowSpuList.length
        return {
          $orig: $orig,
          m0: m0,
          g3: g3,
          g4: g4,
        }
      })
    : null
  var l1 = _vm.__map(_vm.categoryPickList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m1 = _vm.style(200)
    return {
      $orig: $orig,
      m1: m1,
    }
  })
  var m2 = _vm.style(400)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        l0: l0,
        l1: l1,
        m2: m2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }